// extracted by mini-css-extract-plugin
export default {"main":"DigikalaSeller_main__1qBI1"};